import { render, staticRenderFns } from "./EsFormActions.vue?vue&type=template&id=5136a963&scoped=true&"
import script from "./EsFormActions.vue?vue&type=script&lang=js&"
export * from "./EsFormActions.vue?vue&type=script&lang=js&"
import style0 from "./EsFormActions.vue?vue&type=style&index=0&id=5136a963&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136a963",
  null
  
)

export default component.exports